import React from 'react';
import PropTypes from 'prop-types';
import LogRocket from 'logrocket';
import CartBadge from './CartBadge';
import AppLinkContainer from './AppLinkContainer';
import Brand from './Brand';
import UserMenu from './UserMenu';
import Suggest from './Suggest';
import SuggestPopUp from './SuggestPopUp';
import WebMediaQuery from './WebMediaQuery';
import {createFragmentContainer, graphql} from 'react-relay';
import CartBadgeLoader from "./CartBadgeLoader";

import AppService from '../service/AppService';
import AppConfig from '../domain/AppConfig';
import AppConfigService from '../service/AppConfigService';
const appConfig:AppConfig = AppService.appConfig();

class UserSection extends React.Component {

  static propTypes = {
    viewer: PropTypes.any,
    suggestSearch: PropTypes.any,
    disableSuggest: PropTypes.bool,
    disableCartBadge: PropTypes.bool,
    disableLogin: PropTypes.bool,
    disableMarketplaceBanner: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    let keyword = AppConfigService.getSearchKeyword()?AppConfigService.getSearchKeyword():'';

    this.state = {
      suggestKeyword: keyword,
      showSuggest: false,
    }
  }

  identifyLogRocketUser(viewer) {
    if (viewer && !viewer.isInternalIp && viewer.userId &&
      AppConfigService.shouldInitLogRocket(viewer) ) {
      LogRocket.identify(viewer.userId);
    }
  }

  componentDidMount() {
    this.identifyLogRocketUser(this.props.viewer);
  }

  componentDidUpdate(prevProps) {
    if (this.props.viewer && !prevProps.viewer) {
      this.identifyLogRocketUser(this.props.viewer);
    }
  }

  onSuggestChange(keyword) {
    this.setState({
      suggestKeyword: keyword,
    })
  }

  onClickSuggestPopUp() {
    this.setState({
      showSuggest: !this.state.showSuggest,
    })
  }

  render() {

    let {
      viewer,
      suggestSearch,
      disableSuggest,
      disableLogin,
      disableCartBadge,
    } = this.props;

    let _viewer = viewer?viewer:{};

    let {
      suggestKeyword,
    } = this.state;

    let tdComponentName = 'header_searchBox';
    let suggest = undefined;
    if (!disableSuggest) {
      suggest = <Suggest tdId={`td-parts-td-${tdComponentName}`} suggestSearch={suggestSearch} suggestKeyword={suggestKeyword} onSuggestChange={::this.onSuggestChange} {...this.props} />;
    }

    return (
      <div className="stripColumn">
        <div className="aw-main strip">
          <Brand/>
          {!disableSuggest &&
            <WebMediaQuery desktopOnly={true}>
              <div>
                {suggest}
              </div>
            </WebMediaQuery>
          }
          <div className="util-container">
            {(appConfig.isAperzaCatalogTop) && <AppLinkContainer />}
            {!disableSuggest &&
              <WebMediaQuery mobileOnly={true}>
                <div className={`util-item`}>
                  <SuggestPopUp suggest={suggest} onClick={::this.onClickSuggestPopUp}/>
                </div>
              </WebMediaQuery>
            }
            { (!_viewer.isBusiness || (_viewer.isActiveBusinessCart)) &&
              <div className="util-item">
                {!disableCartBadge && <CartBadgeLoader/>}
              </div>
            }
            <div className="util-item">
              {/*<UserMenuLoader />*/}
              {!disableLogin && <UserMenu viewer={viewer}/>}
            </div>
          </div>
        </div>
        {
          (AppConfigService.isAperzaSearchResultPage() || AppConfigService.isAperzaSearchNewsResultPage() || this.state.showSuggest) &&
          <div className="suggest-mobile">
            {!disableSuggest &&
            <WebMediaQuery mobileOnly={true}>
              {suggest}
            </WebMediaQuery>
            }
          </div>
        }

      </div>
    )
  }

}

export default createFragmentContainer(UserSection, {
    viewer: graphql`
        fragment UserSection_viewer on Viewer {
            id
            userId
            isInternalIp
            isLogRocket
            isLogin
            isBusiness
            isActiveBusinessCart
            ...UserMenu_viewer
        }
    `}
);